import { useMemo } from "react"
import { useColumnState } from "lib/@components/managed-columns/use-column-state.js"
import { resolveColumns, TRAILING_COLUMN_COUNT } from "lib/@components/managed-columns/column-state.mjs"

export function useManagedColumns({ storageKey, allColumns, defaultPinnedField = null, minVisible = 1 }) {
    const currentFields = useMemo(getCurrentFields, [allColumns])
    const [columnState, actions] = useColumnState(storageKey, currentFields, defaultPinnedField, minVisible)
    const resolvedColumns = useMemo(getResolvedColumns, [allColumns, columnState])
    const columnCount = resolvedColumns.length + TRAILING_COLUMN_COUNT

    return { allColumns, columnState, resolvedColumns, columnCount, minVisible, ...actions }

    function getCurrentFields() {
        return allColumns.map((column) => column.field)
    }

    function getResolvedColumns() {
        return resolveColumns(allColumns, columnState)
    }
}
